import {LocalStorageObject} from '../Utilities';

export class SubmitOrderResponse implements LocalStorageObject {
  orderNumber: string | null = null;
  orderId: number | null = null;
  redirectUrl: string | null = null;
  provideDownloadLinkEventIds: number[] = [];
  jwt: string | null = null;
  userLanguage: string | null = null;

  fromStorage(data: any) {
    const obj = new SubmitOrderResponse();
    obj.orderId = data.orderId || null;
    obj.userLanguage = data.userLanguage || null;
    obj.jwt = data.jwt || null;
    obj.provideDownloadLinkEventIds = data.provideDownloadLinkEventIds || [];
    obj.redirectUrl = data.redirectUrl || null;
    obj.orderNumber = data.orderNumber || null;

    return obj;
  }
}
